import { render } from "./coloredRibbons.vue?vue&type=template&id=ac269ff2"
import script from "./coloredRibbons.vue?vue&type=script&lang=js"
export * from "./coloredRibbons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__